import React from 'react';
import { connect } from 'react-redux';
import { Grid, Typography, withStyles } from '@material-ui/core';
import { ProductoItem } from '../index';

const ProductosList_ = (props) => {
  let {
    forms,
    productos,
    categorias,
    detalle_stock,
    classes,
    modalHandler,
    dialogHandler,
    handleChangeStockInput,
    handleToggleEditarDetalleStock,
    handleSubmitEditarDetalleStock,
  } = props;

  const renderizarProductos = () => {
    if (productos.length > 0) {
      return productos.map((producto, index) => {
        return (
          <ProductoItem
            categorias={categorias}
            detalle_stock={detalle_stock}
            producto={producto}
            forms={forms}
            dialogHandler={dialogHandler}
            modalHandler={modalHandler}
            handleChangeStockInput={handleChangeStockInput}
            handleToggleEditarDetalleStock={handleToggleEditarDetalleStock}
            handleSubmitEditarDetalleStock={handleSubmitEditarDetalleStock}
            key={index}
          />
        );
      });
    } else {
      return (
        <Grid item xs={12}>
          <div className={classes.list_item}>
            <Typography className={classes.list_item_title}>
              No se han encontrado productos
            </Typography>
            <Typography className={classes.list_item_subtitle}>
              Tene en cuenta que se busca en función a todos los filtros
            </Typography>
          </div>
        </Grid>
      );
    }
  };

  return (
    <Grid container spacing={24} alignItems="center">
      {renderizarProductos()}
    </Grid>
  );
};

const styles = (theme) => ({
  bigAvatar: {
    [theme.breakpoints.up('lg')]: {
      width: 60,
      height: 60,
    },
  },
  list_item: {
    backgroundColor: '#fff',
    border: '1px solid rgba(0, 0, 0, 0.12)',
    borderRadius: '4px',
    padding: '15px 7.5px',
    [theme.breakpoints.up('sm')]: {
      padding: '15px 10px',
    },
  },
  list_item_title: {
    fontSize: '1rem',
    [theme.breakpoints.up('sm')]: {
      fontSize: '1.2rem',
    },
  },
  list_item_subtitle: {
    fontSize: '0.9rem',
    color: 'rgba(0, 0, 0, 0.54)',
  },
  list_item_ver_stock: {
    fontSize: '0.8rem',
    marginTop: '5px',
    textDecoration: 'underline',
    cursor: 'pointer',
  },
});

const mapStateToProps = (state) => {
  return {
    productos: state.productos,
    categorias: state.categorias,
    auth: state.auth,
  };
};

const mapDispatchToProps = null;

export const ProductosList = connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles, { withTheme: true })(ProductosList_));
